<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('menu.danger_reports')"/>

        <search-filter
            v-if="!detailsMode"
            :is-danger-report="true"
            :user="user"
            class="my-2"
            @search="fetchDangerReports"/>

        <div class="col-12 d-flex justify-content-end py-2"
             v-if="!detailsMode"
        >
            <button
                class="btn btn-success form-button"
                @click.stop="createDangerReport"
            >
                {{ $t('common.add_new') }}
            </button>
            <button
                variant="outline-success"
                class="btn btn-outline-success form-button"
                @click="downloadDangerReportExcel"
                :disabled="results.length === 0"
            >
                {{ $t('common.download_excel') }}
            </button>
        </div>
        <danger-report-result-summary v-if="results && results.length > 0" :results="results"/>
        <danger-report-list
            v-if="results"
            :results="results"
            @details="showReportDetails"/>

        <Transition name="fade">
            <danger-report-details
                v-if="detailsMode"
                id="details"
                ref="details"
                :report="reportDetails"
                :is-observer="isObserver"
                :user="user"
                @close="showReportsList"
                @closeAndUpdate="closeAndUpdate"
            />
        </Transition>
        <DangerReportModal
            @close="hideDangerReport"
            @cancel="hideDangerReport"
            @closeAndUpdate="hideDangerReport"
            :show-report="showDangerReportCreateForm"
        />
        <div v-if="loading"
             id="loader"
             class="spinner">
        </div>
    </div>
</template>

<script>
import SearchFilter from '../search/SearchFilter'
import {restApi} from '../mixins/RestApiMixin'
import {downloadHelper} from '../mixins/DownloadMixin'
import DangerReportList from "./DangerReportList";
import DangerReportDetails from "./DangerReportDetails";
import DangerReportModal from "@/components/dangerreports/DangerReportModal.vue";
import Navbar from "@/components/utils/Navbar";
import DangerReportResultSummary from "./DangerReportResultSummary.vue";

export default {
    name: 'danger-reports',
    components: {
        DangerReportResultSummary,
        Navbar, DangerReportModal, DangerReportDetails, DangerReportList, SearchFilter},
    mixins: [restApi, downloadHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
        isObserver: Boolean
    },
    data: function () {
        return {
            loading: false,
            results: [],
            detailsMode: false,
            reportDetails: null,
            lastSearchedParams: null,
            showDangerReportCreateForm: false,
        }
    },
    methods: {

        createDangerReport: function () {
            this.showDangerReportCreateForm = true
        },
        hideDangerReport: function () {
            this.showDangerReportCreateForm = false
        },

        fetchDangerReports: function (params) {
            if (params) {
                this.loading = true
                this.lastSearchedParams = params
                this.restFetchParams(this.dangerReportUrl, params, this.handleResponse)
            }
        },
        handleResponse: function (response) {
            if (response) {
                this.results = response.data
            }
            this.loading = false
        },
        showReportDetails: function (details) {
            this.reportDetails = details
            this.detailsMode = true
        },
        showReportsList: function () {
            this.detailsMode = false
        },
        closeAndUpdate: function () {
            this.detailsMode = false
            this.fetchDangerReports(this.lastSearchedParams)
        },
        downloadDangerReportExcel: function () {
            this.loading = true
            this.restGetDownloadFile(this.dangerReportUrl + '/excel',
                this.getCommonReportParams(this.lastSearchedParams),
                this.downloadSuccess,
                this.downloadFail)
        },
        downloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('danger_report.danger_report_file_name'))
        },
        downloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        }
    }
}
</script>
